var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { API_URL, DEBUG } from "./config";
import { sendBackendData } from "./xhrbackend";
import { Util } from "./util";
import { marked } from "marked";
export const iconOpenGroup = 'fa-caret-down';
export const iconClosedGroup = "fa-caret-right";
export class DomHelper {
    static runTour(tour) {
        return __awaiter(this, void 0, void 0, function* () {
            const bodyNode = document.getElementById('rudi-body');
            if (bodyNode) {
                for (const tourItem of tour) {
                    console.log("-->addTourBox", tourItem);
                    DomHelper.addTourBox(bodyNode, tourItem);
                    yield new Promise(resolve => setTimeout(resolve, tourItem.duration));
                }
                const tourModal = document.getElementById('rudi-tour');
                tourModal.innerHTML = '';
            }
        });
    }
    static appendSpinner(parentNode) {
        let cssClasses = ['fa-light', 'fa-spinner-scale', 'fa-spin', 'fa-2xl'];
        if (parentNode)
            DomHelper.replaceAllChildren(parentNode, 'i', cssClasses, []);
    }
    static removeSpinner(parentNode) {
        const spinNode = parentNode.querySelector('.fa-spinner-scale');
        if (spinNode)
            spinNode.remove();
    }
    static uploadFileForMistralOCR(username, formData, bearerToken, callback) {
        return __awaiter(this, void 0, void 0, function* () {
            const xhr = new XMLHttpRequest();
            xhr.open('POST', `${API_URL}/public/file/${username}?ocr=true`, true);
            xhr.setRequestHeader('Authorization', 'Bearer ' + bearerToken);
            xhr.onreadystatechange = function () {
                if (xhr.readyState === XMLHttpRequest.DONE) {
                    if (xhr.status === 200) {
                        console.log('Upload successful');
                        const result = JSON.parse(xhr.responseText);
                        callback(result);
                    }
                    else {
                        console.log('Error', xhr.statusText);
                    }
                }
            };
            xhr.send(formData);
        });
    }
    static uploadFileForOCR(username, formData, bearerToken, callback) {
        return __awaiter(this, void 0, void 0, function* () {
            const xhr = new XMLHttpRequest();
            xhr.open('POST', `${API_URL}/public/file/ocr`, true);
            xhr.setRequestHeader('Authorization', 'Bearer ' + bearerToken);
            xhr.onreadystatechange = function () {
                if (xhr.readyState === XMLHttpRequest.DONE) {
                    if (xhr.status === 200) {
                        console.log('Upload successful');
                        const result = JSON.parse(xhr.responseText);
                        callback(result);
                    }
                    else {
                        console.log('Error', xhr.statusText);
                    }
                }
            };
            xhr.send(formData);
        });
    }
    static addAppIcon(parentNode, app, tooltip) {
        const nodeIconDiv = DomHelper.appendNode(parentNode, "div", ['rudi-app-icon'], []);
        let nodeIcon;
        if (app.odAppIconType == "file") {
            const attr = [
                { attr: "src", value: app.odAppIcon },
                { attr: "alt", value: "Icon representing the Application" }
            ];
            nodeIcon = DomHelper.appendNode(parentNode, 'img', ['rudi-app-icon'], attr);
        }
        else if (app.odAppIconType == "font") {
            nodeIcon = DomHelper.appendNode(nodeIconDiv, 'i', app.odAppIcon.split(" "), []);
        }
        if (nodeIcon && tooltip)
            DomHelper.addToolTip(nodeIcon, tooltip);
    }
    static appendInputText(parent, formname, cssClasses, additionalLabelAttr, name, label, value, additionalInputAttributes, disabled, predefinedFormSection, omitErrorArea, type = 'text') {
        let section;
        if (predefinedFormSection)
            section = predefinedFormSection;
        else
            section = DomHelper.appendNode(parent, 'section', [...cssClasses, 'rudi-form-input-group'], []);
        if (label) {
            DomHelper.appendNode(section, "label", [...cssClasses, 'form-label', 'mb-0', 'mt-1'], [
                ...additionalLabelAttr,
                { attr: "for", value: `${formname}-${name.toLowerCase()}` },
                { attr: "id", value: `${formname}-${name.toLowerCase()}-label` }
            ], label);
        }
        const inputAttr = additionalInputAttributes ? additionalInputAttributes : [];
        if (!omitErrorArea)
            DomHelper.appendNode(section, "div", ['od-form-invalid-msg', 'disabled'], [], '', `${name}-invalid`);
        const inputNode = DomHelper.appendNode(section, "input", [...cssClasses, 'form-control'], [
            ...inputAttr,
            { attr: "id", value: formname + "-" + name.toLowerCase() },
            { attr: "name", value: name },
            { attr: "type", value: type },
            { attr: "value", value: value ? value : '' }
        ], label);
        if (disabled)
            inputNode.disabled = disabled;
        return inputNode;
    }
    static appendInputNumber(parent, formname, cssClasses, additionalLabelAttr, name, label, valueDefault, additionalInputAttributes) {
        const section = DomHelper.appendNode(parent, 'section', ['rudi-form-input-group'], []);
        if (label) {
            DomHelper.appendNode(section, "label", [...cssClasses, 'form-label', 'mb-0', 'mt-1'], [
                ...additionalLabelAttr,
                { attr: "for", value: formname + "-" + name.toLowerCase() }
            ], label);
        }
        const inputAttr = additionalInputAttributes ? additionalInputAttributes : [];
        return DomHelper.appendNode(section, "input", [...cssClasses, 'form-control'], [
            ...inputAttr,
            { attr: "id", value: formname + "-" + name.toLowerCase() },
            { attr: "name", value: name },
            { attr: "type", value: 'number' },
            { attr: "value", value: valueDefault ? valueDefault + "" : '' }
        ], label);
    }
    static appendMultiNameSelect(parent, formname, cssClasses, additionalLabelAttr, name, label, bearerToken, schoolid, classid, values, additionalInputAttributes) {
        const section = DomHelper.appendNode(parent, 'section', ['rudi-form-input-group'], []);
        DomHelper.appendNode(section, "label", [...cssClasses, 'form-label', 'mb-0', 'mt-1'], [
            ...additionalLabelAttr,
            { attr: "for", value: formname + "-" + name.toLowerCase() }
        ], label);
        DomHelper.appendNode(section, "div", [], [], "Lehrkräfte und Mitarbeiter_innen, die auch im Chat der Klasse aufgenommen werden sollen.<br>Über die Suche nach z.B. Nachnamen erscheint eine Liste. Einen Klick auf die Person ergänzt diese in der Liste.");
        DomHelper.renderSearchBox(section);
        const nodeSelected = DomHelper.appendNode(parent, 'section', [], [{ attr: 'id', value: 'rudi-form-multiName-group-selected' }]);
        DomHelper.appendNode(nodeSelected, 'h4', [], [], "Bereits zugeordnet:");
        if (values) {
            for (let value of values) {
                DomHelper.renderNameKeyobject(nodeSelected, value, bearerToken, schoolid, classid);
            }
        }
    }
    static renderNameKeyobject(parent, item, bearerToken, schoolid, classid) {
        const itemNode = DomHelper.appendNode(parent, 'div', ['rudi-deletable-item'], [{ attr: 'id', value: 'teacher-' + item.id }]);
        DomHelper.appendNode(itemNode, 'span', [], [], item.name);
        DomHelper.appendNode(itemNode, 'i', ['fa-light', 'fa-circle-xmark'], []);
        itemNode.addEventListener('click', (event) => {
            sendBackendData('', `/school/${schoolid}/class/${classid}/teacher/${item.id}`, 'DELETE', 'application/json', bearerToken, {}, (response) => {
                var _a;
                const responseData = JSON.parse(response.target.response);
                (_a = document.getElementById('teacher-' + item.id)) === null || _a === void 0 ? void 0 : _a.remove();
            });
        });
    }
    static renderSearchBox(parent) {
        const itemNode = DomHelper.appendNode(parent, 'div', ['rudi-multi-searchbox'], [{ attr: 'id', value: 'rudi-multi-searchbox' }]);
        DomHelper.appendNode(itemNode, 'i', ['fa-light', 'fa-magnifiying-glass'], []);
        const searchBox = DomHelper.appendNode(itemNode, 'input', ['form-control'], [{ attr: 'type', value: 'text' }, { attr: 'id', value: 'rudi-multi-searchbox-input' }]);
        const resultArea = DomHelper.appendNode(itemNode, 'div', [], [{ attr: 'id', value: 'rudi-multi-searchbox-result' }]);
    }
    static appendSelect(parent, formname, cssClasses, name, label, values, valueSelected) {
        const section = DomHelper.appendNode(parent, 'section', ['rudi-form-input-group'], []);
        DomHelper.appendNode(section, "label", [...cssClasses, 'form-label', 'mb-0', 'mt-2'], [
            { attr: "for", value: formname + "-" + name.toLowerCase() }
        ], label);
        const select = DomHelper.appendNode(section, "select", [...cssClasses, 'form-select'], [
            { attr: "id", value: formname + "-" + name.toLowerCase() },
            { attr: "name", value: name },
            { attr: "type", value: 'text' },
        ]);
        if (values.length <= 1)
            select.disabled = true;
        for (const option of values) {
            const optionNode = DomHelper.appendNode(select, "option", [...cssClasses, 'form-select'], [{ attr: "value", value: option.value }], option.label);
            optionNode.selected = valueSelected == option.value ? true : false;
        }
        return select;
    }
    static updateSelectOptions(select, cssClasses, values, valueSelected) {
        select.innerHTML = '';
        for (const option of values) {
            const optionNode = DomHelper.appendNode(select, "option", [...cssClasses, 'form-select'], [{ attr: "value", value: option.value }], option.label);
            optionNode.selected = valueSelected == option.value ? true : false;
        }
        return select;
    }
    static appendDivAsInput(parent, cssClasses, name, label, value, id) {
        const section = DomHelper.appendNode(parent, 'section', [...cssClasses, 'rudi-form-input-group'], []);
        if (label && label != '')
            DomHelper.appendNode(section, "label", [...cssClasses, 'form-label', 'mb-0', 'mt-2'], [
                { attr: "for", value: id }
            ], label);
        return DomHelper.appendNode(section, 'div', [...cssClasses, 'od-div-input'], [
            { attr: 'type', value: 'text' },
            { attr: 'name', value: name },
            { attr: 'contenteditable', value: 'true' },
            { attr: 'id', value: id }
        ], value);
    }
    static appendIconWithLink(parent, classList, attributes, uri) {
        const node = document.createElement('a');
        if (attributes) {
            for (const attr of attributes) {
                node.setAttribute(attr.attr, attr.value);
            }
        }
        if (uri)
            node.setAttribute("href", uri);
        this.appendNode(node, 'i', classList);
        parent.appendChild(node);
        return node;
    }
    static appendNodeFirstChild(parent, tag, classList, attributes, text, id) {
        const node = document.createElement(tag);
        for (const className of classList)
            node.classList.add(className);
        if (attributes) {
            for (const attr of attributes) {
                node.setAttribute(attr.attr, attr.value);
            }
        }
        if (id)
            node.setAttribute("id", id);
        if (text)
            node.innerHTML = text;
        parent.insertBefore(node, parent.firstChild);
        return node;
    }
    static appendNode(parent, tag, classList, attributes, text, id) {
        const node = this.createNode(tag, classList, attributes, id, text);
        parent.appendChild(node);
        return node;
    }
    static createFileCard(parent, file) {
        const node = this.createNode('div', ['od-file-card'], [], file.id, '');
        const suffix = file.filename.substring(file.filename.lastIndexOf('.'));
        let icon = '';
        switch (suffix) {
            case '.pdf':
                icon = 'fa-file-pdf';
                break;
            case '.doc':
                icon = 'fa-file-word';
                break;
            case '.docx':
                icon = 'fa-file-word';
                break;
            case '.xslx':
                icon = 'fa-file-excel';
                break;
            default:
                icon = 'fa-file';
        }
        this.appendNode(node, 'i', ['fa-light', icon, 'od-file-card-bg-icon'], []);
        this.appendNode(node, 'p', ['od-file-card-name'], [], file.filename);
        this.appendNode(node, 'p', ['od-file-card-size'], [], `(${Math.round(file.filesize / 1024)} KB)`);
        const iconNode = this.appendNode(node, 'div', ['od-file-card-footer'], []);
        DomHelper.appendNode(iconNode, 'i', ['fa-light', 'fa-trash', 'mouse-pointer'], [{ attr: 'id', value: `delete-${file.id}` }]);
        parent.appendChild(node);
        return node;
    }
    static createNode(tag, classList, attributes, id, text) {
        const node = document.createElement(tag);
        for (const className of classList)
            node.classList.add(className);
        if (attributes) {
            for (const attr of attributes) {
                node.setAttribute(attr.attr, attr.value);
            }
        }
        if (id)
            node.setAttribute("id", id);
        if (text)
            node.innerHTML = text;
        return node;
    }
    static appendNodeAsSibling(sibling, tag, classList, attributes, text, id) {
        const node = this.createNode(tag, classList, attributes, id, text);
        if (sibling.nextSibling && sibling.parentNode) {
            sibling.parentNode.insertBefore(node, sibling.nextSibling);
        }
        else {
            if (sibling.parentNode) {
                sibling.parentNode.appendChild(node);
            }
        }
        return node;
    }
    static appendNodeBefore(sibling, tag, classList, attributes, text, id) {
        const node = this.createNode(tag, classList, attributes, id, text);
        const parentNode = sibling.parentNode;
        if (parentNode)
            parentNode.insertBefore(node, sibling);
        return node;
    }
    static add2DomElement(domId, content) {
        let domContent = document.getElementById(domId);
        if (domContent)
            domContent.innerHTML = content;
    }
    static replaceAllChildren(parent, tag, classList, attributes, text, id) {
        const node = document.createElement(tag);
        for (const className of classList)
            node.classList.add(className);
        if (attributes) {
            for (const attr of attributes) {
                node.setAttribute(attr.attr, attr.value);
            }
        }
        if (id)
            node.setAttribute("id", id);
        if (text)
            node.innerHTML = text;
        parent.replaceChildren(node);
        return node;
    }
    static getFirstParentWithClass(element, className) {
        var _a, _b, _c;
        if (DEBUG)
            console.log("--> getFirstParentWithClass", className);
        let parent = element.parentNode;
        if ((_a = element.classList) === null || _a === void 0 ? void 0 : _a.contains(className)) {
            if (DEBUG)
                console.log("Element is already Element of searched Class -> returning", element);
            return element;
        }
        while (parent) {
            if (DEBUG)
                console.log(parent);
            if (DEBUG && parent.classList)
                console.log(parent.classList, (_b = parent === null || parent === void 0 ? void 0 : parent.classList) === null || _b === void 0 ? void 0 : _b.contains(className));
            if ((_c = parent === null || parent === void 0 ? void 0 : parent.classList) === null || _c === void 0 ? void 0 : _c.contains(className)) {
                if (DEBUG)
                    console.log("We found a matching parent -> returning", element);
                return parent;
            }
            if (parent.parentNode != null)
                parent = parent.parentNode;
            else
                throw "Reached Document Root without finding class";
        }
        throw "No Parent with class found";
    }
    static enableGroupByDN(dn) {
        const node = document.getElementById(dn + "_section");
        node === null || node === void 0 ? void 0 : node.classList.remove("disabled");
        const icon = document.getElementById(dn + "_icon");
        icon === null || icon === void 0 ? void 0 : icon.classList.remove("fa-toggle-off");
        icon === null || icon === void 0 ? void 0 : icon.classList.add();
    }
    static disableGroupByDN(dn) {
        const node = document.getElementById(dn + "_section");
        node === null || node === void 0 ? void 0 : node.classList.add("disabled");
        const icon = document.getElementById(dn + "_icon");
        icon === null || icon === void 0 ? void 0 : icon.classList.add(iconClosedGroup);
        icon === null || icon === void 0 ? void 0 : icon.classList.remove(iconOpenGroup);
    }
    static writeContent2NewTab(content) {
        const newTab = window.open('');
        if (newTab != null) {
            newTab.document.open();
            newTab.document.appendChild(content);
            newTab.document.close();
        }
        else {
            DomHelper.alertMessage("Voucher Anzeige wurde von Pop-Up-Blocker verhindert");
        }
    }
    static alertMessage(message) {
        console.error(message);
    }
    static addCopyToClipboardLink(identifier) {
        const nodeListOf = document.querySelectorAll(identifier);
        nodeListOf.forEach((element) => {
            element.addEventListener('click', () => __awaiter(this, void 0, void 0, function* () {
                try {
                    yield navigator.clipboard.writeText(element.textContent || element.innerHTML);
                    element.classList.add('rudi-clipboard-copy-ok');
                }
                catch (e) {
                    console.log("Copy to clipboard failed", e);
                }
            }));
        });
    }
    static addTableRow(table, data, classList, attributes, hrefIndex = -1, hrefPrefix) {
        const row = this.appendNode(table, 'div', [...classList, 'rudi-table-row'], attributes);
        for (const index in data) {
            const item = data[index];
            if (hrefPrefix && Number(index) === hrefIndex) {
                const td = this.appendNode(row, 'span', [], []);
                this.appendNode(td, 'a', [], [{ attr: 'href', value: `${hrefPrefix}${item}` }], item);
            }
            else {
                this.appendNode(row, 'span', [], [], item);
            }
        }
    }
    static showModal(modalNode) {
        modalNode.style.display = 'block';
    }
    static addDetail(parentNode, list) {
        if (typeof list === "undefined" || list.length == 0)
            return "";
        const detailNode = this.appendNode(parentNode, 'details', []);
        this.appendNode(detailNode, 'summary', [], [], 'Personen einblenden');
        const listNode = this.appendNode(detailNode, 'ul', []);
        for (const item of list) {
            this.appendNode(listNode, 'li', [], [], `${item.displayName} [${item.cn}]`);
        }
    }
    static appendEditableTDNode(tableRowNode, classList, attributes, identifier, value) {
        const tdNode = DomHelper.appendNode(tableRowNode, 'td', classList, attributes);
        DomHelper.appendNode(tdNode, 'div', [], [{ attr: "odName", value: identifier }, { attr: "odEditable", value: 'true' }], value);
        DomHelper.appendNode(tdNode, "div", ['od-form-invalid-msg', 'disabled'], [], '', `${identifier}-invalid`);
        return tdNode;
    }
    static appendEditableDivNode(parentNode, classList, attributes, identifier, value) {
        const sectionNode = DomHelper.appendNode(parentNode, 'section', [], []);
        DomHelper.appendNode(sectionNode, 'div', classList, [...attributes, {
                attr: "odName",
                value: identifier
            }, { attr: "odEditable", value: 'true' }], value);
        DomHelper.appendNode(sectionNode, "div", ['od-form-invalid-msg', 'disabled'], [], '', `${name}-invalid`);
        return sectionNode;
    }
    static showMessage(message, username, bearerToken) {
        if (DEBUG)
            console.log('-->showMessage', `[${new Date().toLocaleString()}] ${message}`);
        const duration = message.duration === -1 ? 500 : message.duration;
        const messageListNode = document.getElementById('rudi-message-box-area');
        if (messageListNode) {
            const messageBoxNode = document.createElement('div');
            messageBoxNode.classList.add('rudi-message-box', message.type);
            const messageBoxHeaderNode = document.createElement('header');
            messageBoxHeaderNode.innerText = message.header;
            messageBoxHeaderNode.classList.add(message.type);
            messageBoxNode.appendChild(messageBoxHeaderNode);
            const messageBoxDivNode = document.createElement('div');
            messageBoxDivNode.classList.add('rudi-message-icon');
            const messageBoxIconNode = document.createElement('i');
            messageBoxIconNode.classList.add('fa-light', message.icon, message.type);
            messageBoxDivNode.appendChild(messageBoxIconNode);
            messageBoxNode.appendChild(messageBoxDivNode);
            const messageBoxMessageNode = document.createElement('div');
            messageBoxMessageNode.classList.add('rudi-message-text');
            const htmlContent = marked(message.message, { breaks: true });
            if (typeof (htmlContent) == "string")
                messageBoxMessageNode.innerHTML = htmlContent;
            messageBoxNode.appendChild(messageBoxMessageNode);
            if (message.interaction && username) {
                if (message.tour) {
                    const interactionNode = DomHelper.appendNode(messageBoxNode, 'div', ['rudi-message-interaction'], []);
                    const buttonNode = DomHelper.appendNode(interactionNode, 'button', ['btn', 'btn-primary', 'mt-2', 'ms-1', 'mt-1',], [{
                            attr: 'id',
                            value: ''
                        }]);
                    DomHelper.appendNode(buttonNode, 'i', ['fa-light', 'fa-cloud-arrow-up', 'me-1'], []);
                    DomHelper.appendNode(buttonNode, 'span', [], [], message.interaction.label);
                    buttonNode.addEventListener('click', (event) => {
                        if (message.tour)
                            DomHelper.runTour(message.tour);
                        sendBackendData('', `/users/${username.toLowerCase()}/signmessage`, "PUT", 'application/json', bearerToken, message, (response) => {
                            if (DEBUG)
                                console.log("Message signed", response);
                            messageBoxNode.classList.remove('show');
                            setTimeout(() => messageBoxNode.remove(), duration);
                        });
                    });
                }
                else if (message.interaction.hidden) {
                    messageBoxIconNode.classList.add('od-clickable');
                    messageBoxIconNode.addEventListener('click', (event) => {
                        sendBackendData('', `/users/${username.toLowerCase()}/signmessage`, "PUT", 'application/json', bearerToken, message, (response) => {
                            if (DEBUG)
                                console.log("Message signed", response);
                            messageBoxNode.classList.remove('show');
                            setTimeout(() => messageBoxNode.remove(), duration);
                        });
                    });
                }
                else {
                    const interactionNode = DomHelper.appendNode(messageBoxNode, 'div', ['rudi-message-interaction'], []);
                    const buttonNode = DomHelper.appendNode(interactionNode, 'button', ['btn', 'btn-primary', 'mt-2', 'ms-1', 'mt-1',], [{
                            attr: 'id',
                            value: ''
                        }]);
                    DomHelper.appendNode(buttonNode, 'i', ['fa-light', 'fa-cloud-arrow-up', 'me-1'], []);
                    DomHelper.appendNode(buttonNode, 'span', [], [], message.interaction.label);
                    buttonNode.addEventListener('click', (event) => {
                        sendBackendData('', `/users/${username.toLowerCase()}/signmessage`, "PUT", 'application/json', bearerToken, message, (response) => {
                            if (DEBUG)
                                console.log("Message signed", response);
                            const appNode = document.querySelector(`[ldap-dn="${message.appdn}"]`);
                            if (appNode) {
                                appNode.classList.remove('disabledbymessage');
                                DomHelper.removeNodesByClassList(appNode, [`tt-${message.appcn}`]);
                            }
                            messageBoxNode.classList.remove('show');
                            setTimeout(() => messageBoxNode.remove(), duration);
                        });
                    });
                }
            }
            messageListNode.appendChild(messageBoxNode);
            setTimeout(() => {
                console.error("-->showMessage", `[${new Date().toLocaleString()}] ${message}`);
                messageBoxNode.classList.add('show');
            }, 100);
            if (message.duration !== -1) {
                setTimeout(() => {
                    console.log("--> Disabling message");
                    messageBoxNode.classList.remove('show');
                    setTimeout(() => messageBoxNode.remove(), duration);
                }, message.duration);
            }
        }
    }
    static showConfirmationMessage(message) {
        return __awaiter(this, void 0, void 0, function* () {
            if (DEBUG)
                console.log('-->showConfirmationMessage', `[${new Date().toLocaleString()}] ${message}`);
            const messageListNode = document.getElementById('rudi-message-box-area');
            const messageBoxNode = document.createElement('div');
            messageBoxNode.classList.add('rudi-message-box', message.type);
            const messageBoxHeaderNode = document.createElement('header');
            messageBoxHeaderNode.innerText = message.header;
            messageBoxHeaderNode.classList.add(message.type);
            messageBoxNode.appendChild(messageBoxHeaderNode);
            const messageBoxDivNode = document.createElement('div');
            messageBoxDivNode.classList.add('rudi-message-icon');
            const messageBoxIconNode = document.createElement('i');
            messageBoxIconNode.classList.add('fa-light', message.icon, message.type);
            messageBoxDivNode.appendChild(messageBoxIconNode);
            messageBoxNode.appendChild(messageBoxDivNode);
            const messageBoxMessageNode = document.createElement('div');
            messageBoxMessageNode.classList.add('rudi-message-text');
            const htmlContent = marked(message.message, { breaks: true });
            if (typeof (htmlContent) == "string")
                messageBoxMessageNode.innerHTML = htmlContent;
            messageBoxNode.appendChild(messageBoxMessageNode);
            const interactionNode = DomHelper.appendNode(messageBoxNode, 'div', ['rudi-message-interaction'], []);
            const buttonNode = DomHelper.appendNode(interactionNode, 'button', ['btn', 'btn-primary', 'mt-2', 'ms-1', 'mt-1',], [{
                    attr: 'id',
                    value: ''
                }]);
            DomHelper.appendNode(buttonNode, 'i', ['fa-light', 'fa-cloud-arrow-up', 'me-1'], []);
            DomHelper.appendNode(buttonNode, 'span', [], [], message.interaction.label);
            const removeBox = () => {
                console.log("--> Disabling message");
                messageBoxNode.classList.remove('show');
                setTimeout(() => messageBoxNode.remove(), 100);
            };
            const cancelButton = DomHelper.appendNode(interactionNode, 'button', ['btn', 'btn-secondary', 'mt-1'], [{
                    attr: 'id',
                    value: ''
                }]);
            DomHelper.appendNode(cancelButton, 'i', ['fa-light', 'fa-circle-xmark'], []);
            DomHelper.appendNode(cancelButton, 'span', [], [], 'Abbruch');
            messageListNode.appendChild(messageBoxNode);
            setTimeout(() => {
                console.error("-->showMessage", `[${new Date().toLocaleString()}] ${message}`);
                messageBoxNode.classList.add('show');
            }, 100);
            return new Promise((resolve) => {
                buttonNode.addEventListener('click', (event) => {
                    removeBox();
                    resolve(true);
                });
                cancelButton.addEventListener('click', (event) => {
                    removeBox();
                    resolve(false);
                });
            });
        });
    }
    static addToolTip(iconNode, tooltip, id) {
        let parentNode = iconNode.parentNode;
        if (!parentNode)
            parentNode = iconNode;
        iconNode.style.cursor = 'pointer';
        let domid;
        if (!id) {
            domid = Util.generateRandomDomId();
        }
        else {
            domid = id;
        }
        if (parentNode) {
            const infoNode = DomHelper.appendNode(parentNode, 'div', ['od-tooltip', domid], [], tooltip);
            iconNode.addEventListener('mouseover', (event) => {
                const scrollTop = window.scrollY || document.documentElement.scrollTop;
                const scrollLeft = window.scrollX || document.documentElement.scrollLeft;
                const targetIcon = event.target;
                const rect = targetIcon.getBoundingClientRect();
                infoNode.style.top = `${rect.bottom + scrollTop}px`;
                infoNode.style.left = `${rect.left + scrollLeft}px`;
                infoNode.style.display = 'block';
            });
            iconNode.addEventListener('mouseout', (event) => {
                infoNode.style.display = 'none';
            });
        }
    }
    static preventDefaultForScrollKeys(e) {
        var keys = { 37: 1, 38: 1, 39: 1, 40: 1 };
        if (keys[e.keyCode]) {
            DomHelper.preventDefault(e);
            return false;
        }
    }
    static preventDefault(e) {
        e.preventDefault();
    }
    static disableScroll() {
        var supportsPassive = false;
        const wheelOpt = supportsPassive ? { passive: false } : false;
        const wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';
        window.addEventListener('DOMMouseScroll', DomHelper.preventDefault, false);
        window.addEventListener(wheelEvent, DomHelper.preventDefault, wheelOpt);
        window.addEventListener('touchmove', DomHelper.preventDefault, wheelOpt);
        window.addEventListener('keydown', DomHelper.preventDefaultForScrollKeys, false);
    }
    static enableScroll() {
        var supportsPassive = false;
        const wheelOpt = supportsPassive ? { passive: false } : false;
        const wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';
        window.removeEventListener('DOMMouseScroll', DomHelper.preventDefault, false);
        window.removeEventListener('keydown', DomHelper.preventDefaultForScrollKeys, false);
    }
    static scrollIntoView(node) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                node.scrollIntoView({ behavior: 'smooth' });
                const offset = 10;
                const nodeRect = node.getBoundingClientRect();
                setTimeout(() => {
                    window.scrollBy({
                        top: (nodeRect.top > 0 ? -offset : offset), behavior: 'smooth'
                    });
                    resolve("done");
                }, 500);
            });
        });
    }
    static resetFormInvalidMessages(formNode) {
        const invalidNodes = formNode.querySelectorAll('.od-form-invalid-msg');
        invalidNodes.forEach(invalidNode => {
            invalidNode.classList.add('disabled');
            invalidNode.innerHTML = "";
        });
    }
    static addInvalidMessage(formNode, inputNode, message) {
        const invalidNode = formNode.querySelector(`#${inputNode.name}-invalid`);
        if (invalidNode) {
            invalidNode.classList.remove('disabled');
            invalidNode.innerHTML = message;
        }
    }
    static addTourBox(parentNode, tourItem) {
        return __awaiter(this, void 0, void 0, function* () {
            let workNode;
            const queryPath = tourItem.path;
            const tooltip = tourItem.message;
            if (queryPath) {
                workNode = document.querySelector(queryPath);
            }
            else {
                workNode = parentNode;
            }
            if (tourItem.click === true)
                workNode.click();
            DomHelper.disableScroll();
            const tourModal = document.getElementById('rudi-tour');
            const tourTextModal = document.createElement('div');
            const tourFrameModal = document.createElement('div');
            if (tourModal && tourTextModal && tourFrameModal) {
                tourModal.innerHTML = "";
                tourTextModal.classList.add('rudi-tour-text');
                const rect = workNode.getBoundingClientRect();
                tourFrameModal.id = 'rudi-tour-frame';
                tourFrameModal.style.top = `${rect.top - 5}px`;
                tourFrameModal.style.left = `${rect.left - 5}px`;
                tourFrameModal.style.width = `${rect.width + 10}px`;
                tourFrameModal.style.height = `${rect.height + 10}px`;
                tourModal.appendChild(tourFrameModal);
                tourModal.appendChild(tourTextModal);
                tourModal.style.display = 'block';
                tourTextModal.innerText = tooltip;
                tourTextModal.style.top = `${rect.bottom + 15}px`;
                tourTextModal.style.left = `${rect.left}px`;
            }
            tourModal.addEventListener('click', () => {
                tourModal.style.display = 'none';
                tourFrameModal.remove();
                DomHelper.enableScroll();
            });
        });
    }
    static disableDefaultNav() {
        const navBar = document.getElementById('appNavigation');
        const aList = navBar.querySelectorAll('a');
        for (const a of aList) {
            a.classList.add('disabled');
        }
    }
    static restoreDefaultNav() {
        const navBar = document.getElementById('appNavigation');
        const aList = navBar.querySelectorAll('a');
        for (const a of aList) {
            if (a.classList.contains('disabled')) {
                a.classList.remove('disabled');
            }
            else {
                a.remove();
            }
        }
    }
    static restoreSearchBar() {
        const searchBarWrapperNode = document.querySelector('section.top-search-bar-wrapper');
        if (searchBarWrapperNode) {
            const oldsearchBars = searchBarWrapperNode.querySelectorAll('.top-search-bar');
            oldsearchBars.forEach(searchBar => {
                if (searchBar.hasAttribute('searchbase')) {
                    searchBar.remove();
                }
                else {
                    searchBar.classList.remove('disabled');
                }
            });
        }
    }
    static createButtonClose(injectNode, username, bearerToken, userPreferences) {
        const buttonNode = DomHelper.appendNode(injectNode, 'button', ['btn', 'btn-primary', 'mt-2', 'ms-1', 'mt-1',], [{
                attr: 'id',
                value: ''
            }]);
        DomHelper.appendNode(buttonNode, 'i', ['fa-light', 'fa-arrow-up', 'me-1'], []);
        DomHelper.appendNode(buttonNode, 'span', [], [], 'schließen');
        buttonNode.addEventListener('click', function (event) {
            const appGroupNode = document.getElementById('appGroups');
            if (appGroupNode)
                appGroupNode.classList.remove('disabled');
            const fullScreenNode = document.getElementById('appFullscreen');
            if (fullScreenNode) {
                fullScreenNode.innerHTML = "";
                fullScreenNode.classList.add('disabled');
            }
            DomHelper.restoreDefaultNav();
            DomHelper.restoreSearchBar();
        });
    }
    static updateCategoryVisibility(paneid, categoryClass, listClass, childClass) {
        const shopNode = document.getElementById(paneid);
        if (shopNode) {
            const categoryNodes = shopNode.getElementsByClassName(categoryClass);
            for (let i = 0; i < categoryNodes.length; i++) {
                const categoryNode = categoryNodes.item(i);
                if (categoryNode) {
                    const enabledNodes = categoryNode.querySelectorAll(`.${childClass}:not(.disabled)`);
                    if (enabledNodes && enabledNodes.length > 0) {
                        categoryNode.classList.remove('disabled');
                    }
                    else {
                        categoryNode.classList.add('disabled');
                    }
                }
            }
        }
    }
    static appendIntWidget(parentElement, name, label, value, id, callback) {
        const widgetNode = DomHelper.appendNode(parentElement, 'div', ['od-widget-int'], []);
        const descIconNode = DomHelper.appendNode(widgetNode, 'div', ['od-desc-icon'], [], '-');
        DomHelper.addToolTip(descIconNode, `${label} verringern`);
        const valueNode = DomHelper.appendNode(widgetNode, 'div', ['od-value'], [
            { attr: 'type', value: 'number' },
            { attr: 'name', value: name },
            { attr: 'contenteditable', value: 'true' },
            { attr: 'id', value: id }
        ]);
        valueNode.innerText = `${value}`;
        const ascIconNode = DomHelper.appendNode(widgetNode, 'div', ['od-asc-icon'], [], '+');
        DomHelper.addToolTip(ascIconNode, `${label} erhöhen`);
        ascIconNode.addEventListener('click', (event) => {
            value++;
            updateValue();
            callback(value);
        });
        descIconNode.addEventListener('click', (event) => {
            value--;
            updateValue();
            callback(value);
        });
        function updateValue() {
            valueNode.textContent = `${value}`;
        }
        return valueNode;
    }
    static appendFormCheckbox(parentElement, id, name, label, value, checked) {
        const rowNode = DomHelper.appendNode(parentElement, 'div', ['form-check']);
        DomHelper.appendNode(rowNode, 'label', ['form-check-label',], [{ attr: 'for', value: id }], label);
        const checboxNode = DomHelper.appendNode(rowNode, 'input', ['form-check-input'], [
            { attr: 'type', value: 'radio' },
            { attr: 'name', value: name },
            { attr: 'value', value: value }
        ], '', id);
        checboxNode.checked = checked;
    }
    static appendCheckboxWidget(parentElement, name, label, value, id, callback) {
        const widgetNode = DomHelper.appendNode(parentElement, 'div', ['od-widget-check'], []);
        const descIconNode = DomHelper.appendNode(widgetNode, 'div', ['od-desc-icon'], []);
        DomHelper.addToolTip(descIconNode, `${label} aktivieren`);
        const valueNode = DomHelper.appendNode(widgetNode, 'div', ['od-value'], [
            { attr: 'type', value: 'number' },
            { attr: 'name', value: name },
            { attr: 'active', value: value ? 'true' : 'false' },
            { attr: 'id', value: id }
        ]);
        const iconNode = DomHelper.appendNode(valueNode, 'div', ['fa-light'], []);
        if (value) {
            iconNode.classList.add('fa-square-check');
        }
        else {
            iconNode.classList.add('fa-square');
        }
        parentElement.addEventListener('click', (event) => {
            if (valueNode.getAttribute('active') == 'true') {
                iconNode.classList.add('fa-square');
                iconNode.classList.remove('fa-square-check');
                valueNode.setAttribute('active', 'false');
                value = false;
            }
            else {
                iconNode.classList.remove('fa-square');
                iconNode.classList.add('fa-square-check');
                valueNode.setAttribute('active', 'true');
                value = true;
            }
            callback(value);
        });
    }
    static appendFilteringSelect(parentElement, name, label, value, id, callback, minCharsToPerformSearch = 0) {
        const widgetNode = DomHelper.appendNode(parentElement, 'div', ['od-widget-filtering-select'], []);
        const inputGroup = DomHelper.appendNode(widgetNode, 'div', ['form-group']);
        DomHelper.appendNode(inputGroup, 'i', ['fa-light', 'fa-search']);
        const valueNode = DomHelper.appendNode(inputGroup, 'div', ['od-value'], [
            { attr: 'type', value: 'text' },
            { attr: 'name', value: `${name}-input` },
            { attr: 'contenteditable', value: 'true' },
            { attr: 'id', value: id },
            { attr: 'value', value: value + '' }
        ]);
        valueNode.innerText = `${label}`;
        valueNode.addEventListener('input', handleSearchInputChange);
        const selectNode = DomHelper.appendNode(widgetNode, 'div', ['od-value-list', 'disabled'], [
            { attr: 'type', value: 'text' },
            { attr: 'name', value: name },
            { attr: 'id', value: id }
        ]);
        DomHelper.appendNode(widgetNode, "div", ['od-form-invalid-msg', 'disabled'], [], '', `${id}-invalid`);
        let searchTimeout;
        function handleSearchInputChange() {
            console.log("-->input triggered");
            const searchString = valueNode.innerText;
            if (searchTimeout) {
                clearTimeout(searchTimeout);
            }
            searchTimeout = setTimeout(() => {
                if (searchString.length >= minCharsToPerformSearch)
                    performSearch(searchString);
            }, 500);
        }
        function performSearch(searchString) {
            console.log("Starting search for ", searchString);
            callback(searchString, selectNode, valueNode);
        }
        return valueNode;
    }
    static appendOption(selectNode, value, label, selected, callback) {
        const additionalClassList = [];
        if (selected)
            additionalClassList.push('selected');
        const optionNode = DomHelper.appendNode(selectNode, "a", [...additionalClassList], [{ attr: "value", value: value + '' }, { attr: "href", value: `#${value}` }], label);
        optionNode.addEventListener('click', callback);
    }
    static removeNodesByClassList(cardNode, classNameList) {
        for (const className of classNameList) {
            const node = cardNode.querySelector(`.${className}`);
            if (node)
                node.remove();
        }
    }
    static removeAllNodesByClassList(cardNode, classNameList) {
        for (const className of classNameList) {
            const nodes = cardNode.querySelectorAll(`.${className}`);
            nodes.forEach(node => {
                node.remove();
            });
        }
    }
    static enableNodesByClassList(cardNode, classNameList) {
        for (const className of classNameList) {
            const node = cardNode.querySelector(`.${className}`);
            if (node)
                node.classList.remove('disabled');
        }
    }
    static disableNodesByClassList(cardNode, classNameList) {
        for (const className of classNameList) {
            const node = cardNode.querySelector(`.${className}`);
            if (node)
                node.classList.add('disabled');
        }
    }
    static appendFavoriteIcon(parentNode, odApp, userPreferences, username, bearerToken, callbackAdd, callbackRemove) {
        var _a;
        let cssClassList = ['fa-light', 'fa-star', 'rudi-app-fav'];
        if (((_a = userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.favorites) === null || _a === void 0 ? void 0 : _a.indexOf(odApp.dn)) >= 0)
            cssClassList.push('selected');
        const iconNode = DomHelper.appendNode(parentNode, 'i', cssClassList, [{ attr: 'rudi-group-dn', value: odApp.dn }, { attr: 'title', value: 'als Favorit markieren' }]);
        iconNode.addEventListener("click", (event) => {
            event.preventDefault();
            const node = event.target;
            if (node.classList.contains("selected")) {
                node.classList.remove("selected");
                callbackRemove(node, username, userPreferences, bearerToken);
            }
            else {
                node.classList.add("selected");
                callbackAdd(node, username, userPreferences, bearerToken);
            }
        });
    }
    static appendColorpickerIcon(parentNode, odApp, userPreferences, username, bearerToken, callbackAdd, callbackRemove) {
        let cssClassList = ['fa-light', 'fa-palette', 'rudi-app-color'];
        const iconNode = DomHelper.appendNode(parentNode, 'i', cssClassList, [{ attr: 'rudi-group-dn', value: odApp.dn }, { attr: 'title', value: 'Farbe durch klicken anpassen' }]);
        iconNode.addEventListener("click", (event) => {
            event.preventDefault();
            console.log("-->colorpicker triggered", odApp.cn);
            const appNode = DomHelper.getFirstParentWithClass(parentNode, 'rudi-app');
            if (appNode) {
                let currentColor = "";
                try {
                    currentColor = Util.getRudiColorFromCallList(appNode.classList);
                    appNode.classList.remove(currentColor);
                }
                catch (e) {
                }
                let nextColor = Util.getNextRudiColor(currentColor);
                appNode.classList.add(nextColor);
                Util.saveColorChange(username, userPreferences, odApp, nextColor, bearerToken);
            }
        });
    }
    static appendDescIcon(footerNode, descriptionNode, appNode, description) {
        let cssClassList = ['fa-solid', 'fa-circle-info', 'rudi-app-desc'];
        let tt = 'Informationen einblenden';
        if (!description || description.length < 1) {
            cssClassList.push('inactive');
            tt = 'keine Infromationen hinterlegt';
        }
        const iconNode = DomHelper.appendNode(footerNode, 'i', cssClassList, [{ attr: 'title', value: tt }]);
        let desEnabled = false;
        iconNode.addEventListener('click', (event) => {
            if (!desEnabled) {
                descriptionNode.classList.remove('disabled');
                appNode.classList.remove('rudi-max-height');
                desEnabled = true;
            }
            else {
                descriptionNode.classList.add('disabled');
                appNode.classList.add('rudi-max-height');
                desEnabled = false;
            }
        });
    }
    static appendHelpIcon(footerNode, odAppHelpLocation, callback) {
        let cssClassList = ['fa-solid', 'fa-square-question', 'rudi-app-help'];
        let tt = 'Hilfe anzeigen';
        if (!odAppHelpLocation || odAppHelpLocation.length < 1) {
            cssClassList.push('inactive');
            tt = 'keine Hilfeseite hinterlegt';
        }
        const iconNode = DomHelper.appendNode(footerNode, 'i', cssClassList, [{ attr: 'targeturl', value: odAppHelpLocation + "" }, { attr: 'title', value: tt }]);
        iconNode.addEventListener('click', (event) => {
            callback(event, odAppHelpLocation);
        });
    }
    static appendCloseSection(appNode, callback) {
        const footerNode = appNode.querySelector('footer');
        this.removeCloseSection(appNode);
        const closeNode = DomHelper.appendNodeBefore(footerNode, 'div', ['rudi-app-close'], []);
        DomHelper.appendNode(closeNode, 'i', ['fa-light', 'fa-arrow-up', 'me-1'], []);
        DomHelper.appendNode(closeNode, 'span', [], [], 'schließen');
        closeNode.addEventListener('click', (event) => {
            closeNode.remove();
            callback();
        });
    }
    static removeCloseSection(appNode) {
        const closeNodes = appNode.querySelectorAll('.rudi-app-close');
        closeNodes.forEach(closeNode => { closeNode.remove(); });
    }
    static getHashValueFromUri(win) {
        const hash = win.location.hash;
        if (hash)
            return hash.substring(1);
        const pathname = window.location.pathname;
        return pathname.substring(1);
    }
    static getSearchParam(uri, param) {
        const url = new URL(uri);
        return url.searchParams.get(param);
    }
    static clickAppById(document, id) {
        const node = document.getElementById(id);
        if (node) {
            const wrapperNode = node.querySelector('.rudi-app-wrapper');
            if (wrapperNode) {
                wrapperNode.click();
                DomHelper.scrollIntoView(wrapperNode).finally();
            }
            else {
                node.click();
                DomHelper.scrollIntoView(wrapperNode).finally();
            }
        }
        else {
            console.log(`No element with ${id} found`);
        }
    }
    static setHeaderTitle(title, subtitle) {
        const h1Node = document.querySelector('section.rudi-header-title h1');
        const h2Node = document.querySelector('section.rudi-header-title h2');
        if (h1Node)
            h1Node.innerHTML = title;
        if (h2Node)
            h2Node.innerHTML = subtitle;
    }
    static disableDefaultNavigation() {
        const navNode = document.querySelector('nav');
        const h2Node = document.querySelector('section.rudi-header-title h2');
        if (navNode)
            navNode.classList.add('disabled');
    }
    static disableDefaultLogin() {
        const loginNode = document.getElementById('rudi-login');
        if (loginNode)
            loginNode.remove();
    }
    static setFocus(orderDetailNode, queryString) {
        const focusNode = orderDetailNode.querySelector(queryString);
        if (focusNode)
            focusNode.focus();
    }
    static getAppIdFromDeepLink(deeplink) {
        const parts = deeplink.split('?');
        return parts[0];
    }
}
